export default __webpack_public_path__ + "static/media/phone.5d80ecec.svg";